
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M35.3 40.4a13.8 13.8 0 01-9.83-4.07l-9.83-9.87 9.83-9.83a13.916 13.916 0 1119.66 19.7 13.77 13.77 0 01-9.83 4.07zM19.18 26.46l8.06 8.06a11.4 11.4 0 100-16.12z"}}),_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M39.54 21.44l1.76 1.77-8.12 8.12-5.8-5.8 1.77-1.77 4.03 4.03z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M29.92 52.54H7.2a3.42 3.42 0 01-3.42-3.42V3.88A3.43 3.43 0 017.2.46h22.72a3.43 3.43 0 013.42 3.42v6.78h-2.5V3.88a.92.92 0 00-.92-.92H7.2a.92.92 0 00-.92.92v45.24a.92.92 0 00.92.92h22.72a.92.92 0 00.92-.92v-6.89h2.5v6.89a3.42 3.42 0 01-3.42 3.42z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M18.56 22.15h-4.35v8.7h4.35v2.5h-6.85v-13.7h6.85zM12.36 4.63h8.41v2.5h-8.41zM22.98 4.63h2.37v2.5h-2.37z"}})])
          )
        }
      }
    